import { render, staticRenderFns } from "./VaTimeline.demo.vue?vue&type=template&id=2f3d2544&"
import script from "./VaTimeline.demo.vue?vue&type=script&lang=js&"
export * from "./VaTimeline.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports